import React, { useState } from 'react';
import { Card, Table, Input, Space, Tooltip } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';
import styles from './System.module.scss';

const { Search } = Input;

const ModuleList = ({ moduleList }) => {
  const [, setSearchText] = useState('');
  const [filteredModules, setFilteredModules] = useState([]);
  const [isFiltered, setIsFiltered] = useState(false);

  // 모듈 목록 파싱
  const parseModuleList = (data) => {
    if (!data || data === 'N/A') return [];
    
    try {
      const modules = [];
      const lines = data.trim().split('\n');
      
      // 헤더 라인 건너뛰기
      const dataLines = lines.slice(1);
      
      dataLines.forEach(line => {
        const parts = line.trim().split(/\s+/);
        if (parts.length >= 3) {
          modules.push({
            name: parts[0],
            size: parts[1],
            usedBy: parts[2],
            status: parts.length > 3 ? parts.slice(3).join(' ') : '',
            key: parts[0]
          });
        }
      });
      
      return modules;
    } catch (error) {
      console.error('Error parsing module list:', error);
      return [];
    }
  };

  const modules = parseModuleList(moduleList);

  const handleSearch = (value) => {
    setSearchText(value);
    if (value) {
      const filtered = modules.filter(module => 
        module.name.toLowerCase().includes(value.toLowerCase()) ||
        module.status.toLowerCase().includes(value.toLowerCase())
      );
      setFilteredModules(filtered);
      setIsFiltered(true);
    } else {
      setFilteredModules([]);
      setIsFiltered(false);
    }
  };

  return (
    <Card 
      title={
        <div>
          적재된 커널 모듈
          <Tooltip title="현재 시스템에 적재된 커널 모듈 목록입니다.">
            <InfoCircleOutlined style={{ marginLeft: 8 }} />
          </Tooltip>
        </div>
      } 
      className={styles.systemCard}
      extra={
        <Space>
          <Search
            placeholder="모듈 검색..."
            allowClear
            onSearch={handleSearch}
            style={{ width: 250 }}
          />
        </Space>
      }
    >
      <Table 
        dataSource={isFiltered ? filteredModules : modules}
        rowKey="key"
        pagination={{ pageSize: 10 }}
        columns={[
          { title: '모듈 이름', dataIndex: 'name', key: 'name' },
          { title: '크기', dataIndex: 'size', key: 'size' },
          { title: '사용 수', dataIndex: 'usedBy', key: 'usedBy' },
          { title: '상태', dataIndex: 'status', key: 'status' }
        ]}
      />
    </Card>
  );
};

export default ModuleList;